import { render, staticRenderFns } from "./tracker-employees-by-sex-widget.vue?vue&type=template&id=4a9371b0&scoped=true&"
import script from "./tracker-employees-by-sex-widget.vue?vue&type=script&lang=js&"
export * from "./tracker-employees-by-sex-widget.vue?vue&type=script&lang=js&"
import style0 from "./tracker-employees-by-sex-widget.vue?vue&type=style&index=0&id=4a9371b0&prod&lang=scss&scoped=true&"
import style1 from "./tracker-employees-by-sex-widget.vue?vue&type=style&index=1&id=4a9371b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9371b0",
  null
  
)

export default component.exports